import React from 'react';

export const OmdaRettsAcademyLogo = () => (
    <div className="omda-service-name">Omda RETTS Academy</div>
);
